function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5797 33.0274C38.2545 33.0274 40.423 30.8051 40.423 28.0637C40.423 25.3224 38.2545 23.1001 35.5797 23.1001C32.9048 23.1001 30.7363 25.3224 30.7363 28.0637C30.7363 30.8051 32.9048 33.0274 35.5797 33.0274Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.0606 28.0636C48.0606 21 42.4722 15.2727 35.5797 15.2727C32.4502 15.2727 29.4325 16.4563 27.1226 18.6709L29.656 21.4582C31.258 19.9309 33.3816 19.0909 35.5797 19.0909C40.4231 19.0909 44.335 23.1 44.335 28.0636C44.335 30.2782 43.5526 32.3782 42.0996 34.02L44.8938 36.5782C46.9429 34.2491 48.0606 31.1945 48.0606 28.0636Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5793 7.25452C30.3262 7.25452 25.3338 9.31634 21.5337 13.0582L24.1044 15.8073C27.1967 12.7527 31.2949 11.0727 35.5793 11.0727C44.7071 11.0727 52.1584 18.7091 52.1584 28.0636C52.1584 32.3782 50.5936 36.4636 47.7249 39.6327L50.4446 42.2291C53.9467 38.3727 55.884 33.3327 55.884 28.0636C55.884 16.5709 46.7935 7.25452 35.5793 7.25452Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5793 0C28.3888 0 21.6082 2.82546 16.4668 7.98001L19.0747 10.7291C23.5082 6.30001 29.3947 3.85637 35.5793 3.85637C48.619 3.85637 59.2371 14.7382 59.2371 28.1019C59.2371 34.3255 56.9272 40.2437 52.7917 44.7491L55.5115 47.3837C60.3175 42.1528 63 35.3182 63 28.1019C62.9627 12.6 50.6681 0 35.5793 0Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5704 57.2727C46.5704 58.3036 45.7508 59.1818 44.7076 59.1818H5.58845C4.58253 59.1818 3.72564 58.3418 3.72564 57.2727V17.1817C3.72564 16.1508 4.54528 15.2727 5.58845 15.2727H16.3928V11.4545H5.58845C2.49618 11.4545 0 14.0127 0 17.1817V57.2727C0 60.4418 2.49618 63 5.58845 63H44.7076C47.7999 63 50.2961 60.4418 50.2961 57.2727V47.2309H46.5704V57.2727Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4734 48.6437C17.4734 46.1618 15.9086 44.7109 13.0026 44.7109H8.01025V56.6619H10.9908V52.4619H12.5183L14.5301 56.6619H17.8459L15.4988 52.0419C16.7282 51.4309 17.4734 50.0946 17.4734 48.6437ZM12.7046 50.3619H10.9535V46.9637H12.6673C13.7105 46.9637 14.4183 47.6509 14.4183 48.6819C14.4183 49.7128 13.785 50.3619 12.7046 50.3619Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0855 47.1547V44.6729H19.1499V56.6238H22.1304V52.1947H26.6384V49.8656H22.1304V47.1547H27.0855Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M31.6309 44.6729H28.6504V56.6238H31.6309V44.6729Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M43.9255 50.591C43.9255 46.7729 41.8391 44.6729 38.337 44.6729H33.6055V56.6238H38.337C41.8391 56.6238 43.9255 54.4092 43.9255 50.591ZM36.5487 54.1801V47.1165H37.9272C39.79 47.1165 40.9077 48.3383 40.9077 50.591C40.9077 52.9583 39.8645 54.1801 37.9272 54.1801H36.5487Z"
});

var SvgRfidIcon = function SvgRfidIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "#333333",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRfidIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rfid-icon.fd99b8f2.svg";
export { ForwardRef as ReactComponent };